export default __webpack_public_path__ + "static/media/rocket.b6933835.svg";